import {client} from '../helpers/api';

export async function postSendCode({email}) {
  const body = {email_id: email};

  const response = await client.post('/api/send-code', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
